import { useQuery } from "@tanstack/react-query";

import { ChangelogComment } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export interface ChangelogCommentRepliesResponse {
  success: boolean;
  items: ChangelogComment[];
  page: number;
  pages: number;
  total: number;
  per_page: number;
  has_next: boolean;
  has_prev: boolean;
}

interface UseGetCommentRepliesParams {
  workspaceId: number;
  commentId: number;
  page?: number;
  perPage?: number;
  enabled?: boolean;
}

export const useGetCommentReplies = ({
  workspaceId,
  commentId,
  page = 1,
  perPage = 50,
  enabled = true,
}: UseGetCommentRepliesParams) => {
  const userToken = useAuth()?.userToken ?? "";

  return useQuery<ChangelogCommentRepliesResponse, Error>({
    queryKey: ["changelogCommentReplies", workspaceId, commentId, page, perPage],
    queryFn: async () => {
      const params = new URLSearchParams({
        page: page.toString(),
        per_page: perPage.toString(),
      });

      const response = await fetch(
        `${ENDPOINTS.changelog_comment_replies(workspaceId, commentId)}?${params.toString()}`,
        {
          method: "GET",
          headers: authHeader(userToken),
        },
      );

      return handleResponse(response);
    },
    enabled: enabled && !!workspaceId && !!commentId && !!userToken,
  });
};
